// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kCZN","colMin":"styles_colMin__2kzit"};